import PropTypes from 'prop-types';
import PropsType from 'props-type';

import './ExcelValidationError.scss';

const propTypes = {
  columnName: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

type ExcelValidationErrorProps = PropsType<typeof propTypes>;

function ExcelValidationError({ columnName, message, type }: ExcelValidationErrorProps) {
  const splitedMessage = message.split('\n');
  return (
    <li className="ExcelValidationError space-2x">
      <p>
        <span className="ExcelValidationError__column ExcelValidationError__text--bold">
          {columnName}
        </span>{' '}
        <span className="ExcelValidationError__text--bold">{type}</span>
        <br />
        {splitedMessage.map((v, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <span key={index}>
            {v}
            <br />
          </span> // eslint-disable-line react/no-array-index-key
        ))}
      </p>
    </li>
  );
}

export default ExcelValidationError;
